module.exports = __webpack_public_path__ + "static/media/reportActive.ba7063f3.svg";